import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
import BackOrderList from '../entities/back-userstorageconfig-list'

interface BackUserStorageConfigState extends ListState<BackOrderList> {
    updateOrdeData: BackOrderList,
}

class BackUserStorageConfigMutations extends ListMutations<BackOrderList>{

}
class BackUserStorageConfig extends ListModule<BackUserStorageConfigState, any, BackOrderList>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<BackOrderList>(),
        loading: false,
        updateOrdeData: null,
        ids: [],
        BaseSkuNums: 0,
        ordertype: 0,
        site: 0
    }
    actions = {
        async getAll(context: ActionContext<BackUserStorageConfigState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/UserStorageConfig/GetList', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<BackOrderList>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async edit(context: ActionContext<BackUserStorageConfigState, any>, payload: any) {
            let rep = await Ajax.post('/api/services/app/UserStorageConfig/edit', payload.data);
        },
        async delete(context: ActionContext<BackUserStorageConfigState, any>, payload: any) {
            let rep = await Ajax.post('/api/services/app/UserStorageConfig/Delete', payload.data);
        },
    };
    mutations = {
        setCurrentPage(state: BackUserStorageConfigState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: BackUserStorageConfigState, pagesize: number) {
            state.pageSize = pagesize;
        }
    }
}

const backUserStorageConfig = new BackUserStorageConfig();
export default backUserStorageConfig;